import { render, staticRenderFns } from "./funesM.vue?vue&type=template&id=7dcaa148"
import script from "./funesM.vue?vue&type=script&lang=js"
export * from "./funesM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports